import type { BlockConfigExport } from '@tmh-website/components/blocks.types';
import { Color } from '@tmh-website/shared/colors';

import type { TextBlockThemeColor } from './TextBlock.theme';

export const textBlockConfig: BlockConfigExport = {
  // If the block should decrease padding to the previous block if they have the some background color
  consecutiveBlockPadding: true,
  // Which fields should be populated by Strapi
  populateOptions: [],
};

export const TEXT_BLOCK_THEME_COLORS: Record<TextBlockThemeColor, TextBlockThemeColor> = {
  [Color.Blue_1000_Deep]: Color.Blue_1000_Deep,
  [Color.Neutral_200_OffWhite]: Color.Neutral_200_OffWhite,
  [Color.Green_1000_Energy]: Color.Green_1000_Energy,
  [Color.Neutral_950_TechDarkGrey]: Color.Neutral_950_TechDarkGrey,
  [Color.Neutral_0_White]: Color.Neutral_0_White,
};
